
<app-error-page errorCode="404" errorText="PAGE_NOT_FOUND_MESSAGE"></app-error-page>